export const TRANSLATIONS = {
  en: {
    nav: { mission: "Mission", president: "President", galleries: "Galleries", involved: "Get Involved", donate: "Donate" },
    hero: {
      badge: "501(c)(3) Non-Profit · Focus Haitian Music",
      l1: "Preserving the", l2: "Soul of Haiti", l3: "through Music", l4: "& Education",
      sub: "We preserve the rich traditions of our homeland and support the Institution Chrétienne d'Haïti (ICDH) — empowering the next generation of Haitian leaders.",
      donate: "Donate Now", involved: "Get Involved", scroll: "Scroll",
    },
    marquee: ["Preserve", "Educate", "Empower", "Haitian Heritage", "Youth Leadership", "Music & Culture", "Community", "Legacy"],
    mission: {
      overline: "Our Mission",
      title: "To preserve, educate, and empower.",
      sub: "Focus Haitian Music (fohamu) bridges the gap between preservation and progress — honoring where we come from while building the future of Haiti.",
      chapters: [
        { title: "Preserve Our Heritage", body: "From the rhythm of the tanbou to the songs passed through generations, Haitian music carries the memory of a people. We safeguard these traditions so they are never lost, and so they continue to inspire." },
        { title: "Support ICDH", body: "Our primary mission is to support the Institution Chrétienne d'Haïti — ensuring every student has access to a world-class education rooted in the rich traditions of our homeland." },
        { title: "Empower the Next Generation", body: "By combining business leadership through programs like FBLA with our deep musical heritage, we prepare the next generation of Haitian leaders to inspire the world." },
      ],
    },
    president: {
      overline: "Message from the President",
      quote: "Welcome to Focus Haitian Music. As President, it is my honor to lead an organization dedicated to the heart of our culture: our music and our youth.",
      quoteHighlight: "our music and our youth.",
      p1: "Through our 501(c)(3) non-profit, we work tirelessly to bridge the gap between preservation and progress. Our primary mission is to support the Institution Chrétienne d'Haïti (ICDH), ensuring that every student has access to a world-class education rooted in the rich traditions of our homeland.",
      p2: "By combining business leadership through programs like the FBLA with our deep musical heritage, we are preparing the next generation of Haitian leaders to inspire the world. Thank you for joining us in our mission to preserve, educate, and empower. Together, we are building the future of Haiti.",
      name: "Herbert Joseph", role: "President, Focus Haitian Music Inc.",
    },
    galleries: {
      fblaOverline: "Programs", fblaTitle: "FBLA Leadership",
      fblaSub: "Future Business Leaders developing the confidence, skills, and vision to lead — at home in Haiti and across the diaspora.",
      fblaCaption: "Youth leadership cohort",
      icdhOverline: "In Haiti", icdhTitle: "ICDH Student Body",
      icdhSub: "The students of the Institution Chrétienne d'Haïti — the heart of our mission and the future we invest in every day.",
      icdhCaption1: "Classroom in Haiti", icdhCaption2: "Cultural celebration",
      soon: "Photos coming soon", progress: "Gallery in progress",
      viewAll: "View all {n} photos", showFewer: "Show fewer photos",
    },
    involved: {
      overline: "Join Us", titleA: "Together, we are building the ", titleB: "future of Haiti.",
      donateTitle: "Give a Donation",
      donateBody: "Every gift directly supports ICDH students and provides scholarships to students in Haiti and the Caribbean, while preserving Haitian music heritage. Give once or monthly.",
      donateBtn: "Donate with Card →",
      zelleLabel: "Or send via Zelle", zelleScan: "Scan the QR code",
      formTitle: "Partner & Volunteer", formSub: "Tell us how you'd like to get involved.",
      name: "Name", email: "Email", iam: "I am a", org: "Organization", message: "Message",
      submit: "Submit", sending: "Sending…", submitted: "Submitted",
      roles: ["Volunteer", "Partner", "Sponsor", "Other"],
      thanks: "Thank you! We'll be in touch soon.",
      fillError: "Please fill in your name, email, and message.",
    },
    stats: {
      overline: "Our Impact",
      title: "Measurable change, made together.",
      note: "Every gift compounds — thank you for helping these numbers grow.",
      items: [
        { value: 964, prefix: "", suffix: "", label: "Students supported in Haiti & the Caribbean" },
        { value: 10, prefix: "", suffix: "", label: "FBLA leadership programs" },
        { value: 35000, prefix: "$", suffix: "+", label: "Raised for education among donors" },
        { value: 25, prefix: "", suffix: "", label: "Years serving the US, Caribbean & Haiti" },
      ],
    },
    newsletter: {
      overline: "Stay Connected",
      title: "Updates from Haiti & the ICDH",
      sub: "Join our community for stories, program news, and ways to help — straight to your inbox.",
      placeholder: "Enter your email",
      button: "Subscribe",
      subscribing: "Subscribing…",
      success: "You're subscribed! Check your inbox.",
      error: "Could not subscribe. Please try again.",
      invalid: "Please enter a valid email address.",
    },
    feature: {
      overline: "A Landmark Moment",
      title: "Celebrating our future leaders",
      body: "At the Marriott Hotel in Haiti, President Herbert Joseph delivered a keynote address and congratulated our winning students — standing alongside the principals of every participating school. A proud celebration of leadership, education, and the promise of the next generation.",
      caption: "President Herbert Joseph · Awards Ceremony · Marriott Hotel, Haiti",
    },
    timeline: {
      overline: "Our Story",
      title: "Milestones in our journey",
      sub: "Focus Haitian Music Inc. (FOHAMU) is named after the Focus Haitian Music Awards.",
      link: "Explore our history",
      items: [
        { year: "1996–1998", title: "Focus Haitian Music Awards at BAM", body: "We organized the Focus Haitian Music Awards for Haitian and Caribbean artists at the Brooklyn Academy of Music (BAM), New York — for the first time in history, all Haitian artists, orchestras, and bands gathered under one roof to celebrate music, like the American Music Awards." },
        { year: "1998", title: "Lifetime Achievement honorees", body: "Coupé Cloué, Tropicana d'Haïti, and Septentrional were honored for their lifetime achievement in Haitian music." },
        { year: "Today", title: "Supporting ICDH & Caribbean students", body: "As a 501(c)(3) non-profit, FOHAMU supports Institution Chrétienne d'Haïti (ICDH) and provides scholarships to students across Haiti and the Caribbean." },
        { year: "Recent", title: "Awards Ceremony at the Marriott, Haiti", body: "President Herbert Joseph delivered a keynote and congratulated winning FBLA students alongside the principals of every participating school." },
      ],
    },
    donorwall: {
      overline: "Our Supporters",
      title: "Made possible by generous hearts",
      sub: "A heartfelt thank you to those helping us preserve, educate, and empower.",
      empty: "Be the first to join our wall of supporters.",
      monthly: "monthly",
    },
    video: {
      overline: "Watch",
      title: "FBLA Awards Ceremony",
      sub: "Highlights from the Focus Haitian Music & FBLA awards.",
      soon: "Video coming soon.",
      captionTitle: "Celebrating Haitian & Caribbean excellence",
      captionBody: "Footage from our FBLA awards ceremony honoring the achievements of ICDH students and young leaders across Haiti and the Caribbean — a tradition rooted in the original Focus Haitian Music Awards.",
    },
    resilience: {
      overline: "A Success Story",
      title: "Rising from the rubble",
      beforeLabel: "Before · The landmark",
      afterLabel: "2026 · Rebuilt",
      beforeCaption: "Institution Chrétienne d'Haïti — once one of Haiti's most beloved landmarks.",
      afterCaption: "The new campus, rebuilt and still rising — as of July 2026.",
      quote: "Falling is heartbreaking. But rising is the most beautiful part of achieving greatness.",
      p1: "On January 12, 2010, the earth roared, and in just 35 seconds a sanctuary of learning collapsed into rubble. Four lives were lost that day, including Danielle Jean Baptiste Joseph, wife of the school's director. Only one man crawled out: director Jean Maret Joseph — broken, but unwilling to let the dream die.",
      p2: "His brother, Professor Herbert Joseph, left everything behind and returned to Haiti for an entire year — overseeing every brick and beam, turning rubble into hope. \"My brother's dream must not die.\" This is what family means. This is what it means to refuse to let a dream die.",
      p3: "Today the school has risen again — a living testimony that love is stronger than death. Hundreds of children now learn where laughter once fell silent. The vision continues: a university for 5,000 students. 5,000 futures. 5,000 reasons to believe in Haiti again.",
      cta: "Be part of the solution — help us build",
    },
    footer: {
      tagline: "A 501(c)(3) non-profit preserving Haitian culture and supporting Institution Chrétienne d'Haïti (ICDH) and other students in Haiti and the Caribbean. Preserve. Educate. Empower.",
      explore: "Explore", giveZelle: "Give via Zelle",
      rights: "All rights reserved.", values: "Preserve · Educate · Empower",
    },
    donate: {
      badge: "Support the mission", title: "Make a Donation",
      onetime: "One-time", monthly: "Monthly", custom: "Custom",
      customPh: "Enter amount", namePh: "Your name (optional)", emailPh: "Email for your receipt (optional)",
      submit: "Continue to Secure Checkout →", redirecting: "Redirecting…",
      secure: "Secure payment powered by Stripe. Test card: 4242 4242 4242 4242",
      invalidAmount: "Please enter a valid amount (min $1).",
      error: "Could not start checkout. Please try again.",
      tierLabels: { seed: "Seed", supporter: "Supporter", advocate: "Advocate", patron: "Patron", benefactor: "Benefactor" },
    },
    pay: {
      confirming: "Confirming your gift…", confirmingSub: "Please wait a moment.",
      thanks: "Thank you!",
      thanksBody: "donation to Focus Haitian Music has been received. You're helping preserve Haitian culture and support ICDH students.",
      processing: "Payment processing", processingSub: "Your payment is still being confirmed. You'll receive a receipt by email shortly.",
      error: "Something went wrong", errorSub: "We couldn't confirm this payment. Please try again.",
      cancelled: "Donation cancelled", cancelledSub: "No charge was made. Whenever you're ready, we'd be grateful for your support.",
      home: "Back to Home",
    },
  },
  fr: {
    nav: { mission: "Mission", president: "Président", galleries: "Galeries", involved: "Participer", donate: "Faire un don" },
    hero: {
      badge: "Organisme 501(c)(3) · Focus Haitian Music",
      l1: "Préserver l'âme", l2: "d'Haïti", l3: "par la musique", l4: "et l'éducation",
      sub: "Nous préservons les riches traditions de notre patrie et soutenons l'Institution Chrétienne d'Haïti (ICDH) — pour former la prochaine génération de leaders haïtiens.",
      donate: "Faire un don", involved: "Participer", scroll: "Défiler",
    },
    marquee: ["Préserver", "Éduquer", "Autonomiser", "Héritage haïtien", "Leadership des jeunes", "Musique et culture", "Communauté", "Héritage"],
    mission: {
      overline: "Notre Mission",
      title: "Préserver, éduquer et autonomiser.",
      sub: "Focus Haitian Music (fohamu) fait le pont entre la préservation et le progrès — en honorant nos origines tout en bâtissant l'avenir d'Haïti.",
      chapters: [
        { title: "Préserver notre héritage", body: "Du rythme du tanbou aux chants transmis de génération en génération, la musique haïtienne porte la mémoire d'un peuple. Nous protégeons ces traditions pour qu'elles ne se perdent jamais et continuent d'inspirer." },
        { title: "Soutenir l'ICDH", body: "Notre mission première est de soutenir l'Institution Chrétienne d'Haïti — en garantissant à chaque élève l'accès à une éducation de classe mondiale ancrée dans les riches traditions de notre patrie." },
        { title: "Autonomiser la prochaine génération", body: "En combinant le leadership entrepreneurial via des programmes comme la FBLA avec notre profond héritage musical, nous préparons la prochaine génération de leaders haïtiens à inspirer le monde." },
      ],
    },
    president: {
      overline: "Message du Président",
      quote: "Bienvenue à Focus Haitian Music. En tant que Président, c'est un honneur de diriger une organisation dédiée au cœur de notre culture : notre musique et notre jeunesse.",
      quoteHighlight: "notre musique et notre jeunesse.",
      p1: "À travers notre organisme 501(c)(3), nous travaillons sans relâche pour faire le pont entre la préservation et le progrès. Notre mission première est de soutenir l'Institution Chrétienne d'Haïti (ICDH), en garantissant à chaque élève l'accès à une éducation de classe mondiale ancrée dans les riches traditions de notre patrie.",
      p2: "En combinant le leadership entrepreneurial via des programmes comme la FBLA avec notre profond héritage musical, nous préparons la prochaine génération de leaders haïtiens à inspirer le monde. Merci de vous joindre à notre mission de préserver, éduquer et autonomiser. Ensemble, nous bâtissons l'avenir d'Haïti.",
      name: "Herbert Joseph", role: "Président, Focus Haitian Music Inc.",
    },
    galleries: {
      fblaOverline: "Programmes", fblaTitle: "Leadership FBLA",
      fblaSub: "De futurs leaders d'entreprise développant la confiance, les compétences et la vision pour diriger — en Haïti et à travers la diaspora.",
      fblaCaption: "Cohorte de jeunes leaders",
      icdhOverline: "En Haïti", icdhTitle: "Les élèves de l'ICDH",
      icdhSub: "Les élèves de l'Institution Chrétienne d'Haïti — le cœur de notre mission et l'avenir dans lequel nous investissons chaque jour.",
      icdhCaption1: "Salle de classe en Haïti", icdhCaption2: "Célébration culturelle",
      soon: "Photos à venir", progress: "Galerie en cours",
      viewAll: "Voir les {n} photos", showFewer: "Afficher moins de photos",
    },
    involved: {
      overline: "Rejoignez-nous", titleA: "Ensemble, nous bâtissons ", titleB: "l'avenir d'Haïti.",
      donateTitle: "Faire un don",
      donateBody: "Chaque don soutient directement les élèves de l'ICDH et offre des bourses aux élèves en Haïti et aux Caraïbes, tout en préservant l'héritage musical haïtien. Donnez une fois ou chaque mois.",
      donateBtn: "Donner par carte →",
      zelleLabel: "Ou envoyez via Zelle", zelleScan: "Scannez le code QR",
      formTitle: "Partenaire et bénévole", formSub: "Dites-nous comment vous souhaitez participer.",
      name: "Nom", email: "Courriel", iam: "Je suis", org: "Organisation", message: "Message",
      submit: "Envoyer", sending: "Envoi…", submitted: "Envoyé",
      roles: ["Bénévole", "Partenaire", "Parrain", "Autre"],
      thanks: "Merci ! Nous vous contacterons bientôt.",
      fillError: "Veuillez remplir votre nom, courriel et message.",
    },
    stats: {
      overline: "Notre Impact",
      title: "Un changement mesurable, ensemble.",
      note: "Chaque don compte — merci de nous aider à faire grandir ces chiffres.",
      items: [
        { value: 964, prefix: "", suffix: "", label: "Élèves soutenus en Haïti et aux Caraïbes" },
        { value: 10, prefix: "", suffix: "", label: "Programmes de leadership FBLA" },
        { value: 35000, prefix: "$", suffix: "+", label: "Collectés pour l'éducation par les donateurs" },
        { value: 25, prefix: "", suffix: "", label: "Années au service des É.-U., des Caraïbes et d'Haïti" },
      ],
    },
    newsletter: {
      overline: "Restez Connectés",
      title: "Nouvelles d'Haïti et de l'ICDH",
      sub: "Rejoignez notre communauté pour des histoires, des nouvelles des programmes et des façons d'aider — directement dans votre boîte de réception.",
      placeholder: "Entrez votre courriel",
      button: "S'abonner",
      subscribing: "Abonnement…",
      success: "Vous êtes abonné ! Vérifiez votre boîte de réception.",
      error: "Abonnement impossible. Veuillez réessayer.",
      invalid: "Veuillez saisir un courriel valide.",
    },
    feature: {
      overline: "Un Moment Marquant",
      title: "Célébrer nos futurs leaders",
      body: "À l'hôtel Marriott en Haïti, le Président Herbert Joseph a prononcé un discours et félicité nos élèves lauréats — aux côtés des directeurs de toutes les écoles participantes. Une fière célébration du leadership, de l'éducation et de la promesse de la prochaine génération.",
      caption: "Président Herbert Joseph · Cérémonie de remise des prix · Hôtel Marriott, Haïti",
    },
    timeline: {
      overline: "Notre Histoire",
      title: "Les grandes étapes de notre parcours",
      sub: "Focus Haitian Music Inc. (FOHAMU) tire son nom des Focus Haitian Music Awards.",
      link: "Découvrir notre histoire",
      items: [
        { year: "1996–1998", title: "Focus Haitian Music Awards au BAM", body: "Nous avons organisé les Focus Haitian Music Awards pour les artistes haïtiens et caribéens à la Brooklyn Academy of Music (BAM), New York — pour la première fois de l'histoire, tous les artistes, orchestres et groupes haïtiens réunis sous un même toit pour célébrer la musique, comme les American Music Awards." },
        { year: "1998", title: "Prix pour l'ensemble de leur carrière", body: "Coupé Cloué, Tropicana d'Haïti et Septentrional ont été honorés pour l'ensemble de leur carrière dans la musique haïtienne." },
        { year: "Aujourd'hui", title: "Soutien à l'ICDH et aux Caraïbes", body: "En tant qu'organisme 501(c)(3), FOHAMU soutient l'Institution Chrétienne d'Haïti (ICDH) et offre des bourses aux élèves à travers Haïti et les Caraïbes." },
        { year: "Récemment", title: "Cérémonie au Marriott, Haïti", body: "Le Président Herbert Joseph a prononcé un discours et félicité les élèves FBLA lauréats aux côtés des directeurs de chaque école participante." },
      ],
    },
    donorwall: {
      overline: "Nos Soutiens",
      title: "Rendu possible par des cœurs généreux",
      sub: "Un grand merci à celles et ceux qui nous aident à préserver, éduquer et autonomiser.",
      empty: "Soyez le premier à rejoindre notre mur de soutiens.",
      monthly: "mensuel",
    },
    video: {
      overline: "Regarder",
      title: "Cérémonie des FBLA Awards",
      sub: "Moments forts des prix Focus Haitian Music & FBLA.",
      soon: "Vidéo à venir.",
      captionTitle: "Célébrer l'excellence haïtienne et caribéenne",
      captionBody: "Images de notre cérémonie des FBLA Awards honorant les réussites des élèves de l'ICDH et des jeunes leaders à travers Haïti et les Caraïbes — une tradition née des premiers Focus Haitian Music Awards.",
    },
    resilience: {
      overline: "Une Histoire de Réussite",
      title: "Renaître des décombres",
      beforeLabel: "Avant · Le monument",
      afterLabel: "2026 · Reconstruit",
      beforeCaption: "Institution Chrétienne d'Haïti — jadis l'un des lieux les plus aimés d'Haïti.",
      afterCaption: "Le nouveau campus, reconstruit et toujours en chantier — en juillet 2026.",
      quote: "Tomber est déchirant. Mais se relever est la plus belle part de la grandeur.",
      p1: "Le 12 janvier 2010, la terre a grondé et, en 35 secondes, un sanctuaire du savoir s'est effondré. Quatre vies furent perdues ce jour-là, dont Danielle Jean Baptiste Joseph, épouse du directeur. Un seul homme s'en est extrait : le directeur Jean Maret Joseph — brisé, mais refusant de laisser mourir le rêve.",
      p2: "Son frère, le Professeur Herbert Joseph, a tout quitté pour revenir en Haïti pendant une année entière — supervisant chaque brique et chaque poutre, transformant les décombres en espoir. « Le rêve de mon frère ne doit pas mourir. » Voilà ce que signifie la famille.",
      p3: "Aujourd'hui, l'école a renaît — un témoignage vivant que l'amour est plus fort que la mort. Des centaines d'enfants apprennent là où le silence régnait. La vision continue : une université pour 5 000 élèves. 5 000 avenirs. 5 000 raisons de croire à nouveau en Haïti.",
      cta: "Faites partie de la solution — aidez-nous à bâtir",
    },
    footer: {
      tagline: "Un organisme 501(c)(3) préservant la culture haïtienne et soutenant l'Institution Chrétienne d'Haïti (ICDH) ainsi que d'autres élèves en Haïti et aux Caraïbes. Préserver. Éduquer. Autonomiser.",
      explore: "Explorer", giveZelle: "Donner via Zelle",
      rights: "Tous droits réservés.", values: "Préserver · Éduquer · Autonomiser",
    },
    donate: {
      badge: "Soutenir la mission", title: "Faire un don",
      onetime: "Unique", monthly: "Mensuel", custom: "Autre",
      customPh: "Saisir un montant", namePh: "Votre nom (facultatif)", emailPh: "Courriel pour votre reçu (facultatif)",
      submit: "Passer au paiement sécurisé →", redirecting: "Redirection…",
      secure: "Paiement sécurisé par Stripe. Carte test : 4242 4242 4242 4242",
      invalidAmount: "Veuillez saisir un montant valide (min 1 $).",
      error: "Impossible de démarrer le paiement. Veuillez réessayer.",
      tierLabels: { seed: "Graine", supporter: "Soutien", advocate: "Défenseur", patron: "Mécène", benefactor: "Bienfaiteur" },
    },
    pay: {
      confirming: "Confirmation de votre don…", confirmingSub: "Veuillez patienter un instant.",
      thanks: "Merci !",
      thanksBody: "don à Focus Haitian Music a bien été reçu. Vous aidez à préserver la culture haïtienne et à soutenir les élèves de l'ICDH.",
      processing: "Paiement en cours", processingSub: "Votre paiement est en cours de confirmation. Vous recevrez un reçu par courriel sous peu.",
      error: "Une erreur est survenue", errorSub: "Nous n'avons pas pu confirmer ce paiement. Veuillez réessayer.",
      cancelled: "Don annulé", cancelledSub: "Aucun montant n'a été débité. Quand vous serez prêt, nous serions reconnaissants de votre soutien.",
      home: "Retour à l'accueil",
    },
  },
};
